import { IStorePackage } from 'models/store/i-store-package.interface';

import { ITradeAssetWithAmount, usePackageAssetsQuery } from './usePackageAssetsQuery';
import { useStorePackageQuery } from './useStorePackageQuery';

export interface IPackageDataQueryResponse {
  packageData: IStorePackage | null;
  assets: ITradeAssetWithAmount[];
  highlightedAssets: ITradeAssetWithAmount[];
  packageLoading: boolean;
  assetsLoading: boolean;
  packageError: string | null;
  assetsError: string | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export const usePackageDataQuery = (id: string | undefined): IPackageDataQueryResponse => {
  const {
    data: packageData,
    loading: packageLoading,
    error: packageError,
    refresh: refreshPackage,
  } = useStorePackageQuery(id);

  const {
    assets,
    highlightedAssets,
    loading: assetsLoading,
    error: assetsError,
    refresh: refreshAssets,
  } = usePackageAssetsQuery(packageData);

  const loading = packageLoading || assetsLoading;
  const error = packageError || assetsError;

  const refresh = () => {
    refreshPackage();
    refreshAssets();
  };

  return {
    packageData,
    assets,
    highlightedAssets,
    packageLoading,
    assetsLoading,
    packageError,
    assetsError,
    loading,
    error,
    refresh,
  };
};
